var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      attrs: {
        effect: "dark",
        content: "最后更新时间与实际数据预计有10-20分钟延迟",
        placement: "top",
      },
    },
    [
      _c("label", { staticClass: "lastUpdateTime" }, [
        _vm._v("最后更新时间：" + _vm._s(_vm.time)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }